export default class NurtextValidator {
    static isAnswerCorrect(answer) {
        return true;
    }
}